// Single source of truth for product taxonomy in the UI.
// Matches backend Literal in /app/backend/server.py InventoryItemCreate.
// Order matches the client's printed Rice Village order form (top-to-bottom).
export const CATEGORY_LABELS = {
  macaron:          "Macarons",
  macaron_seasonal: "Seasonal Macarons",
  gelato_pan:       "Gelato Pans",
  gelato_pint:      "Gelato Pints",
  gelato_pop:       "Gelato Pops",
  doggy_macaron:    "Doggy Macarons",
  packaging:        "Packaging Requests",
  other:            "Other Items",
  accessory:        "Accessories",
};

export const CATEGORY_ORDER = [
  "macaron",
  "macaron_seasonal",
  "gelato_pan",
  "gelato_pint",
  "gelato_pop",
  "doggy_macaron",
  "packaging",
  "other",
  "accessory",
];

export const CATEGORY_UNITS = {
  macaron:          "box (70 pcs)",
  macaron_seasonal: "box (70 pcs)",
  gelato_pan:       "pan",
  gelato_pint:      "case of 6",
  gelato_pop:       "case of 10",
  doggy_macaron:    "case of 10",
  packaging:        "pcs",
  other:            "unit",
  accessory:        "unit",
};
